export const UI_updateShowLogoutModalFlagReducer = {
  UI_updateShowLogoutModalFlag: (state, action) => {
    state.showLogoutPopupModal = action.payload;
  },
};
